import { reactive, watchEffect } from "vue";
import useUserAccount, { clientId } from "@/account/use-user-account";
import { PlayerContactApi } from "@/api-connector/sazka-api/methods/player-contact-api";

const userConsents = reactive({
    personalisation: false,
});

const initData = async () => {
    const { waitForUserAccount } = useUserAccount();
    await waitForUserAccount();

    watchEffect(async () => {
        if (clientId.value) {
            userConsents.personalisation = await PlayerContactApi.getContestPersonalisation();
        } else {
            userConsents.personalisation = false;
        }
    });
};

let isInited = false;
export function useUserConsents() {
    if (!isInited) {
        isInited = true;
        initData();
    }

    return {
        userConsents,
    };
}
